import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tooltip-arrow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.isTooltipVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString($setup.message), 1)
      ]))
    : _createCommentVNode("", true)
}